import React from 'react';
import { Row, Col, Card, Transfer, Form, Input } from 'antd';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { KompassBranches } from '../index';
import styles from './styles.less';
import DownloadAsXLS from '../DownloadAsXLS';

const FormItem = Form.Item;

class BranchesCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      branchesData: [],
      subBranches: [],
      prevSelectedKompassBranchesIds: [],
      prevCodesBuffer: [],
      targetGroup: {},
      branchesBuff: [],
    };
  }

  componentDidMount() {
    if (this.props.app.useCustomBranches) {
      this.props.dispatch({ type: 'branches/loadList',
        payload: {
          filter: {
            client_id: this.props.app.selectedClient.id,
          },
        } }).then(() => {
        const branchesData = [];
        this.props.branches.branchesList.forEach((item) => {
          branchesData.push({
            key: item.id,
            title: item.name,
            description: item.description,
          });
        });
        this.setState({ branchesData });
      });
    }
  }

  filterOption(inputValue, option) {
    return option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  }

  handleTransferChange(branches) {
    this.props.setBranches(branches);
    this.setState({ branchesBuff: branches });
    this.props.form.setFieldsValue({
      selectedBranches: branches.length || '',
    });
  }

  includesSubBranches(codes) {
    const { subBranches } = this.state;
    const converted = subBranches.map(sub => !!codes.find(code => sub.id === code));
    return !converted.includes(false);
  }

  formatTransferArray(data) {
    const formatted = [];
    data.forEach((item) => {
      formatted.push({
        key: item.id,
        title: this.props.branchesData ? item.label : item.name,
      });
    });
    return formatted;
  }

  handleKompassBranchesTransfer(selectedKompassBranchesIds, direction) {
    const { subBranches, prevSelectedKompassBranchesIds, prevCodesBuffer } = this.state;
    let prev = [];
    let uniques = [];
    const parentCodes = [];
    const removed = prevCodesBuffer.filter(code => selectedKompassBranchesIds.indexOf(code) !== -1);
    const prevCodes = direction === 'left' ? removed : prevCodesBuffer;

    if (!subBranches.length && selectedKompassBranchesIds.length) {
      prev = selectedKompassBranchesIds;
    } else if (subBranches.length && this.includesSubBranches(selectedKompassBranchesIds)) {
      parentCodes.push(subBranches.find(e => e.id === selectedKompassBranchesIds[0]).parent_id);
    } else {
      uniques = [...selectedKompassBranchesIds.filter((id) => {
        return prevSelectedKompassBranchesIds.indexOf(id) === -1;
      })];
    }
    let codes = [...parentCodes, ...prev, ...uniques, ...prevCodes];
    codes = [...new Set(codes)];
    this.setState({
      prevSelectedKompassBranchesIds: selectedKompassBranchesIds,
      prevCodesBuffer: codes,
    });
    this.props.setClassificationCodes(codes);
  }

  render() {
    const { app, form, branchesData, intl, branches, targetKeys } = this.props;
    const superAdmin = this.props.app.user && this.props.app.user.super_admin;
    const setTargetKeys = branchesData ? targetKeys : this.state.branchesBuff;

    return (<div>
      {app.useCustomBranches ?
        <Card>
          <h3><FormattedMessage id="Component.TargetGroup.Branches.Title" /></h3>
          <p><FormattedMessage id="Component.TargetGroup.Branches.Description" /></p>
          <Row type="flex" gutter={32}>
            <Col span={24}>
              <FormItem>
                {form.getFieldDecorator('selectedBranches')(<Input style={{ display: 'none' }} />)}
              </FormItem>
              <h4 className={styles.transferLeftColumnHeader}>
                <FormattedMessage id="Component.TargetGroup.Branches.AvailableBranches" />
              </h4>
              <h4 className={styles.transferRightColumnHeader}>
                <FormattedMessage id="Component.TargetGroup.Branches.SelectedBranches" />
              </h4>
              {form.getFieldDecorator('SELECTED_BRANCHES_TRANSFER')(
                <Transfer
                  listStyle={{ width: '43%', height: 600 }}
                  dataSource={branchesData || this.formatTransferArray(branches.branchesList)}
                  showSearch
                  locale={{
                    searchPlaceholder: intl.formatMessage({ id: 'Component.TargetGroup.Branches.Search' }),
                    notFoundContent: intl.formatMessage({ id: 'Component.TargetGroup.Branches.NoItems' }),
                  }}
                  filterOption={this.filterOption}
                  targetKeys={setTargetKeys}
                  onChange={this.handleTransferChange.bind(this)}
                  render={item => item && item.title}
                />,
              )}
            </Col>
          </Row>
          <Row type="flex" gutter={32}>
            <Col span={24} className={styles.topMiddleMargin}>
              {superAdmin && <DownloadAsXLS />}
            </Col>
          </Row>
        </Card> :
        <Card>
          <h3><FormattedMessage id="Component.TargetGroup.ClassificationCodes.Title" /></h3>
          <KompassBranches
            titles={[
              this.props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.MainBranch' }),
              this.props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.SubBranch' }),
              this.props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.SelectedBranch' }),
            ]}
            onTransfer={this.handleKompassBranchesTransfer.bind(this)}
            getFieldDecorator={form.getFieldDecorator}
            selectedBranchesData={this.props.selectedBranchesData}
            setSubBranches={subBranches => this.setState({ subBranches })}
          />
        </Card>}
    </div>);
  }
}

export default connect(({ app, branches }) => ({ app, branches }))(injectIntl(BranchesCard));



// WEBPACK FOOTER //
// ./src/components/BranchesCard/BranchesCard.js